import React, { useEffect } from "react";

import { FormLogin } from "./styles";
import { ContainerPublic as Container } from "../../../styles/GlobalStyles";
import Input from "../../../components/Input";
import logoImg from "../../../assets/senai_sidebar.png";
import { useHistory } from "react-router-dom";
import Header from "../../../components/Header";
import { useState } from "react";
import { useRef } from "react";
import { api } from "../../../services/api";
import { signIn } from "../../../services/security";
import Alerts from "../../../components/Alerts";
import InputPassword from "../../../components/InputPassword";

function LoginAdmin() {
  const history = useHistory();

  const headerLinks = [{ label: "Empresa", to: "/" }];

  const btnEnviarRef = useRef();

  const [admin, setAdmin] = useState({
    usuario: "",
    senha: "",
  });

  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  //habilita / desabilita botão
  useEffect(() => {
    const adminProps = Object.values(admin);

    let buttonDisabled = true;

    if (admin.usuario.length > 3) {
      adminProps.some((p) => {
        if (p === "") {
          buttonDisabled = true;
          return true;
        }
        buttonDisabled = false;
        return false;
      });
    }

    btnEnviarRef.current.disabled = buttonDisabled;
  }, [admin]);

  //manipular o loading
  useEffect(() => {
    if (loading) {
      btnEnviarRef.current.disabled = true;
      btnEnviarRef.current.innerHTML = "Verificando...";
    } else {
      btnEnviarRef.current.disabled = false;
      btnEnviarRef.current.innerHTML = "Entrar";
    }
  }, [loading]);

  const handlerInput = (e) => {
    setAdmin({ ...admin, [e.target.id]: e.target.value });
  };

  const entrar = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const retorno = await api.post("/sessao/admin", admin);

      signIn(retorno.data);

      history.push("/admin/home");
    } catch (e) {
      if (e.response) {
        setAdmin({ ...admin, senha: "" });
        document.querySelector("#senha").focus();
        setLoading(false);
        return setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: e.response.data.erro,
        });
      }
      setLoading(false);
      setMensagem({
        show: true,
        titulo: "Erro",
        detalhe: "Erro no servidor, tente novamente mais tarde.",
      });
    }
  };

  return (
    <Container>
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
      <Header links={headerLinks} />
      <FormLogin onSubmit={entrar}>
        <header>
          <img src={logoImg} alt="Logo do Senai" />
        </header>
        <section>
          <h1>Bem-vindo ao SENAI Job</h1>
          <Input
            type="text"
            id="usuario"
            placeholder="Seu usuário"
            label="Usuário"
            maxLength={18}
            value={admin.cnpj}
            handler={handlerInput}
            required
          />
          <InputPassword
            id="senha"
            type="password"
            placeholder="* * * * * *"
            label="Senha"
            value={admin.senha}
            handler={handlerInput}
            required
          />
          <button ref={btnEnviarRef}>Entrar</button>
        </section>
      </FormLogin>
    </Container>
  );
}

export default LoginAdmin;
